import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full py-16 border-t border-gray-100">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-bold text-navy">© 2026 Veric · veric.co</p>
            <div className="flex gap-4 text-sm font-semibold text-navy/50">
              <a href="#" className="hover:text-navy transition-colors underline underline-offset-4 decoration-navy/10">Privacy Policy</a>
              <a href="#" className="hover:text-navy transition-colors underline underline-offset-4 decoration-navy/10">Contact</a>
            </div>
          </div>
          
          <div className="max-w-md">
            <p className="text-xs font-medium text-navy/40 leading-relaxed uppercase tracking-wider">
              Veric is an independent platform. Not affiliated with any school, district, or government agency.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}